module.exports = __webpack_public_path__ + "static/media/1.3f90d3e9.jpg";